export const MAX_IMAGE_COMPONENT_IMAGES = 12;

const coerceString = (value) => {
    if (value == null) return '';
    return String(value);
};

const buildFallbackAlt = (baseAlt, index) => {
    const trimmed = coerceString(baseAlt).trim();
    if (trimmed) {
        return index === 0 ? trimmed : `${trimmed} ${index + 1}`;
    }
    return `Gallery image ${index + 1}`;
};

export const normalizeImageGallery = (comp = {}, fallback = {}) => {
    const fallbackAlt = coerceString(fallback.alt ?? comp?.alt ?? '');
    const fallbackCaption = coerceString(fallback.caption ?? comp?.caption ?? '');
    const fallbackNsfa = !!(fallback.nsfa ?? comp?.nsfa);
    const rawImages = Array.isArray(comp?.images) ? comp.images : [];

    const normalizedFromArray = rawImages
        .map((item, index) => {
            if (!item) return null;
            if (typeof item === 'string') {
                const url = coerceString(item).trim();
                if (!url) return null;
                return {
                    url,
                    alt: buildFallbackAlt(fallbackAlt, index),
                    caption: index === 0 ? fallbackCaption : '',
                    nsfa: fallbackNsfa,
                };
            }
            const url = coerceString(item.url || item.imageUrl || '').trim();
            if (!url) return null;
            return {
                url,
                alt: coerceString(item.alt || buildFallbackAlt(fallbackAlt, index)),
                caption: coerceString(item.caption ?? (index === 0 ? fallbackCaption : '')),
                nsfa: item.nsfa != null ? !!item.nsfa : fallbackNsfa,
            };
        })
        .filter(Boolean);

    const normalized = normalizedFromArray.length > 0
        ? normalizedFromArray
        : (() => {
            const singleUrl = coerceString(comp?.url || comp?.imageUrl || '').trim();
            if (!singleUrl) return [];
            return [{
                url: singleUrl,
                alt: buildFallbackAlt(fallbackAlt, 0),
                caption: fallbackCaption,
                nsfa: fallbackNsfa,
            }];
        })();

    return normalized.slice(0, MAX_IMAGE_COMPONENT_IMAGES);
};
